import {
	ADD_GAME_TYPE_PENDING,
	IS_NOT_SUBMITTING_SEARCHES,
	IS_SUBMITTING_SEARCHES,
	REMOVE_GAME_TYPE_PENDING,
	SET_SELECTED_GAME_TYPE,
} from "react/redux/actions/matchSelection";

const initialState = {
	submittingSearches: false,
	gameTypesPending: {},
	selectedGameTypeId: null,
};

export default (state = initialState, action) => {
	switch(action.type) {
		case SET_SELECTED_GAME_TYPE: {
			return {
				...state,
				selectedGameTypeId: action.payload,
			};
		}
		case ADD_GAME_TYPE_PENDING: {
			const gameTypesPending = { ...state.gameTypesPending };
			gameTypesPending[action.payload] = true;
			return {
				...state,
				gameTypesPending,
			};
		}
		case REMOVE_GAME_TYPE_PENDING: {
			const gameTypesPending = { ...state.gameTypesPending };
			delete gameTypesPending[action.payload];

			return {
				...state,
				gameTypesPending,
			};
		}
		case IS_SUBMITTING_SEARCHES: {
			return {
				...state,
				submittingSearches: true
			};
		}
		case IS_NOT_SUBMITTING_SEARCHES: {
			return {
				...state,
				submittingSearches: false
			};
		}
		default:
			return state;
	}
};